<template>
  <el-card :body-style="{ padding: '0px' }">
    <img v-if="book.cover" :src="book.cover" class="image" />
    <img v-else src="../assets/default_book.jpg" class="image" />
    <div style="padding: 14px">
      <span>{{ book.title }}</span>
      <div class="bottom">
        <p class="authors">{{ book.authors.join("; ") }}</p>
      </div>
      <div class="bottom">
        <el-rate v-model="book.rating" disabled text-color="#ff9900"> </el-rate>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      book: {},
      bookCover: "../assets/default_book.jpg",
      currentDate: new Date(),
    };
  },
  created() {
    this.book = this.value;
    if (this.book.cover) {
      this.bookCover = this.book.cover;
    }
  },
};
</script>
<style>
.authors {
  font-size: 14px;
  color: rgb(97, 95, 95);
}

.bottom {
  margin-top: 13px;
  margin-bottom: 13px;
  line-height: 12px;
  align-items: center;
  text-align: center;
}

.button {
  padding: 0;
  min-height: auto;
}

.image {
  width: 100%;
  height: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
